/**
 * Tenant Module Repository
 * Handles all tenant-module-related API calls
 */

import { apiClient } from '../client'

export interface Permission {
  id: number
  app_module_id: number
  permission_key: string
  status: number
  created_by?: number | null
  updated_by?: number | null
  created_at: Date
  updated_at: Date
}

export interface Module {
  id: number
  en_name: string
  ar_name?: string | null
  description?: string | null
  status: number
  created_by?: number | null
  updated_by?: number | null
  created_at: Date
  updated_at: Date
  permissions: Permission[]
}

export interface TenantModule {
  id: number
  tenant_id: number
  module_id: number
  created_by?: number | null
  updated_by?: number | null
  created_at: Date
  updated_at: Date
  module: Module | null
}

class TenantModuleRepository {

  async getAll(): Promise<Module[]> {
    return apiClient.get<Module[]>('/tenant-modules')
  }

  /**
   * Get tenant-module by ID
   */
  async getById(id: number): Promise<TenantModule> {
    return apiClient.get<TenantModule>(`/tenant-modules/${id}`)
  }

  /**
   * Create a new tenant-module
   */
  async create(data: {
    tenant_id: number
    module_id: number
    created_by?: number
  }): Promise<TenantModule> {
    return apiClient.post<TenantModule>('/tenant-modules', data)
  }

  /**
   * Update an existing tenant-module
   */
  async update(id: number, data: {
    tenant_id?: number
    module_id?: number
    updated_by?: number
  }): Promise<TenantModule> {
    return apiClient.put<TenantModule>(`/tenant-modules/${id}`, data)
  }

  /**
   * Delete a tenant-module
   */
  async delete(id: number): Promise<{ message: string }> {
    return apiClient.delete<{ message: string }>(`/tenant-modules/${id}`)
  }
}

// Export singleton instance
export const tenantModuleRepository = new TenantModuleRepository()

